// extracted by mini-css-extract-plugin
export default {"recommendSlides":"index_recommendSlides_s4Csv clearfix"};